import s from "./style.module.scss";
import clsx from "clsx";

export const SpinLoader = () => {
  return (
    <div className={s.container}>
      <span className={s.loader}></span>
    </div>
  );
};
